export const DEFAULT_HOME_SERMONS = [
  {
    url: 'https://www.youtube.com/watch?v=CPYLVjm1OW8&t=8s',
    thumbnail: 'https://img.youtube.com/vi/CPYLVjm1OW8/hqdefault.jpg',
    alt: 'Sermon 1',
  },
  {
    url: 'https://www.youtube.com/watch?v=ZL7eadUcxFA',
    thumbnail: 'https://img.youtube.com/vi/ZL7eadUcxFA/hqdefault.jpg',
    alt: 'Sermon 2',
  },
  {
    url: 'https://www.youtube.com/watch?v=QFBUdzbTQg8&t=8s',
    thumbnail: 'https://img.youtube.com/vi/QFBUdzbTQg8/hqdefault.jpg',
    alt: 'Sermon 3',
  },
  {
    url: 'https://www.youtube.com/watch?v=_tAaAh-aB4E&t=5s',
    thumbnail: 'https://img.youtube.com/vi/_tAaAh-aB4E/hqdefault.jpg',
    alt: 'Sermon 4',
  },
];

export const DEFAULT_HOME_SERMONS_MORE_LINK = 'https://www.youtube.com/@psagchurch/videos';

export function resolveHomeSermons(getContent) {
  const stored = getContent('home.sermons.items', null);
  if (Array.isArray(stored) && stored.length) {
    return stored.map((item, index) => ({
      url: item.url || DEFAULT_HOME_SERMONS[index]?.url || '',
      thumbnail: item.thumbnail || DEFAULT_HOME_SERMONS[index]?.thumbnail || '',
      alt: item.alt || DEFAULT_HOME_SERMONS[index]?.alt || `Sermon ${index + 1}`,
    }));
  }

  return DEFAULT_HOME_SERMONS.map((item, index) => ({
    ...item,
    thumbnail: getContent(`home.sermons.${index}.thumbnail`, item.thumbnail),
  }));
}
